import { useState } from 'react';
import {
  Theme,
  Button,
  ButtonWidth,
  ButtonStyles,
  RadioButton,
  Input,
  useTranslation,
  ButtonIconPosition,
  IconAnimationClassName,
} from '@nextgen-web-framework/all';
import styles from './DeliveryTrackingInput.module.scss';
import { DeliveryTrackingInputProps, TrackNowInputFields } from './types/propsTypes';

const DeliveryTrackingInput = (props: DeliveryTrackingInputProps) => {
  const t = useTranslation();
  const { loading, orderId } = props;
  const DeliveryTrackData = [
    {
      id: 'accountId',
      title: t('order.deliveryTracking.accountNumber'),
    },
    {
      id: 'orderNumber',
      title: t('order.deliveryTracking.orderNumber'),
    },
  ];
  const [activeRadioButton, setActiveRadioButton] = useState(
    orderId ? DeliveryTrackData[1].id : DeliveryTrackData[0].id,
  );
  const [searchFormData, setSearchFormData] = useState<TrackNowInputFields>({
    accountId: '',
    orderNumber: orderId || '',
  });
  const activeSearchInput = DeliveryTrackData.find((item) => item.id === activeRadioButton);
  const onRadioButtonClick = (id: string) => {
    setActiveRadioButton(id);
  };
  function trackNowBtnClick() {
    props.onTrackNowClick && props.onTrackNowClick({ [`${activeSearchInput?.id}`]: searchFormData[activeRadioButton] });
  }
  return (
    <div className={styles['delivery-tracking-input-container']}>
      <div className={styles['delivery-tracking-input-title']}>{t('order.deliveryTracking.searchMessage')}</div>
      <div className={styles['delivery-tracking-input-selection']}>
        {DeliveryTrackData.map((item) => (
          <RadioButton
            checked={item.id === activeRadioButton}
            onChange={() => {
              onRadioButtonClick(item.id);
            }}
            label={item.title}
            theme={item.id === activeRadioButton ? Theme.PURPLE : Theme.BLACK}
            key={item.id}
          />
        ))}
      </div>
      <div className={styles['delivery-tracking-input-box']}>
        {activeSearchInput && (
          <Input
            name={activeSearchInput?.id}
            id={activeSearchInput?.id}
            theme={Theme.PURPLE}
            required
            value={searchFormData[activeSearchInput.id]}
            label={activeSearchInput.title}
            onChange={(e) => {
              setSearchFormData((prev) => ({
                ...prev,
                [`${e.target.name}`]: e.target.value,
              }));
            }}
            type="text"
          />
        )}
      </div>
      <div className={styles['delivery-tracking-input-submit']}>
        <Button
          buttonStyle={ButtonStyles.SOLID}
          onClick={() => trackNowBtnClick()}
          disabled={!searchFormData[activeRadioButton]}
          title={t('order.deliveryTracking.trackNow')}
          buttonWidth={ButtonWidth.FULL_WIDTH}
          {...(loading && {
            disabled: true,
            iconPosition: ButtonIconPosition.RIGHT,
            icon: {
              iconName: 'spinner-third',
              iconAnimationClassName: IconAnimationClassName.SPIN,
            },
          })}
        />
      </div>
    </div>
  );
};

export default DeliveryTrackingInput;
